import React, { useState } from 'react';
import { Mail, MapPin, MessageCircle, Send, Loader2 } from 'lucide-react';
import { sendContact } from '../lib/api';
import logger from '../lib/logger';

const ContactPage = () => {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      await sendContact(form);
      setSent(true);
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch (err) {
      logger.error(err);
      setError('Could not send your message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const inputCls = 'w-full bg-zinc-950 border border-zinc-800 text-white px-4 py-3 rounded text-sm focus:outline-none focus:border-[#909090]';

  return (
    <div className="bg-black text-white min-h-screen">
      <div className="max-w-[1200px] mx-auto px-4 lg:px-8 py-16 grid md:grid-cols-[1fr_1.4fr] gap-12">
        <div>
          <p className="text-[#909090] text-sm uppercase tracking-widest mb-3">Contact</p>
          <h1 className="text-4xl font-bold mb-5">Get in touch.</h1>
          <p className="text-zinc-400 mb-8 leading-relaxed">
            Questions about a product, a COA, or your order? Our team is here to help.
          </p>
          <ul className="space-y-5">
            <li className="flex items-start gap-3">
              <Mail className="text-[#909090] mt-1" size={20} />
              <div>
                <p className="text-white font-medium">Email</p>
                <p className="text-zinc-400 text-sm">info@hydrohealth.store</p>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="text-[#909090] mt-1" size={20} />
              <div>
                <p className="text-white font-medium">Address</p>
                <p className="text-zinc-400 text-sm">Hydro Health<br/>Dublin<br/>Ireland</p>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <MessageCircle className="text-[#909090] mt-1" size={20} />
              <div>
                <p className="text-white font-medium">Live chat</p>
                <p className="text-zinc-400 text-sm">Mon&ndash;Fri, 9:00&ndash;17:00 CET</p>
              </div>
            </li>
          </ul>
        </div>

        <form onSubmit={handleSubmit} className="bg-zinc-950 border border-zinc-900 rounded p-7">
          {sent && (
            <div className="mb-5 p-3 bg-[#909090]/10 border border-[#909090]/30 text-[#909090] text-sm rounded">
              Thanks! We&rsquo;ll get back to you within 24 hours.
            </div>
          )}
          {error && <div className="mb-5 p-3 bg-red-500/10 border border-red-500/30 text-red-400 text-sm rounded">{error}</div>}
          <div className="grid grid-cols-2 gap-3 mb-3">
            <input required placeholder="Your name" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className={inputCls} />
            <input required type="email" placeholder="Your email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className={inputCls} />
          </div>
          <input required placeholder="Subject" value={form.subject} onChange={(e) => setForm({...form, subject: e.target.value})} className={`${inputCls} mb-3`} />
          <textarea required rows={6} placeholder="Your message..." value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} className={`${inputCls} resize-none`} />
          <button disabled={submitting} className="mt-4 inline-flex items-center gap-2 bg-[#909090] hover:bg-[#a8a8a8] text-black font-semibold px-7 py-3 rounded transition-colors disabled:opacity-60">
            {submitting ? <><Loader2 className="animate-spin" size={16}/> Sending...</> : <>Send message <Send size={16} /></>}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactPage;
